module.exports = __webpack_public_path__ + "img/bookingbg.4c9128c5.png";